<!-- 
Change password page.
Users will be redirected to this if they are being forced to change their password.
(Voluntary password changes use the ChangePasswordDialog instead.)
-->
<template>
  <v-container>
    <v-layout>
      <v-flex 
        xs12 sm8 md6 lg4
        offset-sm2 offset-md3 offset-lg4
      >
        <h1 class="display-1 mb-3 mt-5">Password change required</h1>
        <change-password-panel @changed="done"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ChangePasswordPanel from "@/components/users/ChangePasswordPanel.vue";
import { SIGN_IN_SET_REDIRECT } from "@/store/users/mutation-types";

export default {
  name: "ChangePassword",
  components: { ChangePasswordPanel },
  methods: {
    done() {
      let redirect = this.$store.state.users.user.redirect;
      if (redirect) {
        this.$store.commit(SIGN_IN_SET_REDIRECT, null);
      } else {
        redirect = "/";
      }
      this.$router.push({ path: redirect });
    }
  }
};
</script>
